export const SITE_QUERY_PARAM = 'site'
export const LOADING_TEXT = 'Loading...'
